import React, { useRef, useEffect, useMemo } from 'react'
import PropTypes from 'prop-types'

import { decode, encodeAll } from '@aytm/app/insights/dashboard/lib/sanitize'

import { InputTextarea } from 'primereact/inputtextarea'

import { MAX_SUBJECT_TITLE_LENGTH } from '@aytm/app/insights/dashboard/lib/config'

import './Subject.scss'

const CLASS = 'insights-portal-editor-subject'

const textareaKeyDown = event => {
  if ('Enter' === event.key) event.preventDefault()
}

const Subject = props => {
  const className = props.className || CLASS

  const editor = useMemo(() => props.editor || {}, [props.editor])
  const editorErrors = useMemo(() => editor.errors || {}, [editor.errors])
  const titleError = useMemo(() => ('title' in editorErrors ? editorErrors.title : null), [editorErrors])

  const wait = Boolean(editor.state)

  const subject = useMemo(() => editor.data || {}, [editor.data])
  const text = subject?.text || ''

  const editorType = editor.type || ''
  const lastEditorType = useRef(editorType)

  const textRef = useRef()

  const titleChange = event => {
    if (props.onEditorChange) {
      props.onCheck?.('title', event.target.value)
      const newText = encodeAll(event.target.value || '')
      const newData = Object.assign({}, { ...editor.data, text: newText })
      props.onEditorChange({ action: 'change', data: newData })
    }
  }

  const placeholder = props.subjectType
    ? `${props.subjectType[0].toUpperCase()}${props.subjectType.slice(1)} name`
    : 'Name'

  const inputComponent =
    'edit' === editorType ? (
      <div className={`${className}-editor`}>
        <InputTextarea
          ref={textRef}
          readOnly={wait}
          className={`${className}-input${titleError ? ` p-invalid` : ''}`}
          value={decode(text)}
          placeholder={placeholder}
          maxLength={MAX_SUBJECT_TITLE_LENGTH}
          onChange={titleChange}
          onKeyDown={textareaKeyDown}
        />
      </div>
    ) : 'change' === editorType ? (
      <>{props.children}</>
    ) : (
      <>{props.children}</>
    )

  useEffect(() => {
    if (lastEditorType.current !== editorType) {
      lastEditorType.current = editorType
    }
  }, [editorType])

  return (
    <div className={className} style={props.style}>
      {inputComponent}
    </div>
  )
}

Subject.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any,
  style: PropTypes.object,
  editor: PropTypes.object,
  subjectType: PropTypes.string,
  onEditorChange: PropTypes.func,
  onCheck: PropTypes.func
}

export default Subject
